import { experiment, DestinationFeatureFlags } from '@lib/experiment';

const VDM_V2_SCHEMA_VERSION = '1.1';
type VdmConnectionConfig = { destination?: Record<string, unknown> | null } | null;

const gaVdmDestinations = new Set([
  'INTERCOM_V2',
  'LINKEDIN_AUDIENCE',
  'FB_CUSTOM_AUDIENCE',
  'CUSTOMERIO_AUDIENCE',
  'GOOGLE_ADWORDS_REMARKETING_LISTS',
  'ZOHO',
  'TIKTOK_AUDIENCE',
  'CUSTOM_AUDIENCE',
  'ITERABLE_AUDIENCE',
]);

export const isVdmNextEnabledForDestination = (destType: string): boolean =>
  gaVdmDestinations.has(destType) ||
  experiment.isDestinationFeatureEnabled(destType, DestinationFeatureFlags.vdmNext);

export const isVdmV2Connection = (config?: VdmConnectionConfig): boolean =>
  config?.destination?.schemaVersion === VDM_V2_SCHEMA_VERSION;
